<template>
  <span>
    <label :name="name" :class="{pending}" v-if="type == 'checkbox'" @mousedown="userSet" @keydown="userSet"><input type="checkbox" v-model="newValue"><span class="checkable"><slot></slot></span></label>
    <input :name="name" :class="{pending}" v-if="type == 'text'" type="text" v-model="newValue" @mousedown="userSet" @keydown="userSet" @blur="$emit('blur', $event)" @keyup.enter="$emit('enter', newValue)" :placeholder="placeholder">
    <input :name="name" :class="{pending}" v-if="type == 'email'" type="email" v-model="newValue" @mousedown="userSet" @keydown="userSet" @blur="$emit('blur', $event)" @keyup.enter="$emit('enter', newValue)" :placeholder="placeholder">
    <input :name="name" :class="{pending}" v-if="type == 'password'" type="password" v-model="newValue" @mousedown="userSet" @keydown="userSet" @blur="$emit('blur', $event)" @keyup.enter="$emit('enter', newValue)" :placeholder="placeholder">
    <input :name="name" :class="{pending}" v-if="type == 'datetime-local'" type="datetime-local" v-model="newValue" @mousedown="userSet" @keydown="userSet" @blur="$emit('blur', $event)" :placeholder="placeholder">
    <input :name="name" :class="{pending}" v-if="type == 'time'" type="time" v-model="newValue" @mousedown="userSet" @keydown="userSet" @blur="$emit('blur', $event)" :placeholder="placeholder">
  </span>
</template>

<script>
export default {
  data () {
    return {
      newValue: null,
      user_set: false,
      pending: false,
    }
  },
  props: [
    'name',
    'type',
    'currentValue',
    'display',
    'placeholder'
  ],
  created () {
    this.newValue = this.currentValue
  },
  methods: {
    userSet () {
      this.user_set = true
    },
    focus () {
      this.$el.children[0].focus()
    }
  },
  watch: {
    newValue: function () {
      if (this.user_set) {
        this.pending = true
        
        this.$emit('change', this.newValue)
        this.user_set = false
        if (this.display == 'current') {
          this.newValue = this.currentValue
        }
      }
    },
    currentValue () {
      if (!this.user_set) {
        this.pending = false
      }
      this.newValue = this.currentValue
    }
  }
}
</script>